export const ASSETS_PATH = `${process.env.PUBLIC_URL}/assets`;